import React from 'react'
import TestBankService from '../../components/test/TestBankService'
import Navigation from '../../components/common/Navigation'

const TestBank: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navigation />
      
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">🧪 Test Bank Question Service</h1>
          
          <div className="space-y-6">
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
              <h2 className="text-lg font-semibold text-blue-900 mb-2">ℹ️ Hướng dẫn sử dụng</h2>
              <p className="text-blue-800 text-sm">
                Trang này giúp kiểm tra và debug Bank Question Service. Sử dụng các nút bên dưới để:
              </p>
              <ul className="text-blue-800 text-sm mt-2 list-disc list-inside">
                <li><strong>Test File Access:</strong> Kiểm tra khả năng truy cập file database</li>
                <li><strong>Debug Bank Structure:</strong> Kiểm tra cấu trúc thư mục bank</li>
                <li><strong>Count Questions:</strong> Đếm số câu hỏi có sẵn</li>
                <li><strong>Generate Quiz:</strong> Tạo bài kiểm tra ngẫu nhiên</li>
              </ul>
            </div>
            
            <TestBankService />
          </div>
        </div>
      </div>
    </div>
  )
}

export default TestBank
